import React, { useEffect, useState } from "react";
import Recent from "../Notifications/Recent";
import Allocated from "../Notifications/Allocated";
import Closed from "../Notifications/Closed";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const CompanyNotifications = () => {
  const [activeTab, setActiveTab] = useState("Recent");
  const [siteList, setSiteList] = useState(null);
  const [sites, setSites] = useState("");
  const [companies, setCompanies] = useState(null);

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("Notifications", JSON.stringify(type));
  };

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSiteList();
  }, []);

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && (
          <Recent
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Allocated" && (
          <Allocated
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Closed" && (
          <Closed
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyNotifications;
